<template>
    <div>
        <loading-gdb :propObject="$store.state.rh.questionarios_loading" text="Carregando Questionários" />
        <v-row>
            <modal-gdb :code="modal_code"

                toolbar-title="Questionário"
                :ref="modal_code">
                <template v-slot:activate-slot>
                    <slot name="modal-activate">
                        <v-btn>Novo Questionário</v-btn>
                    </slot>
                </template>
                <template v-slot:body>
                    <card-item>
                        <template v-slot:text>
                            <FormQuestionario @on-create-form="onCreatedForm"/>
                        </template>
                    </card-item>
                </template>
            </modal-gdb>
            <v-spacer></v-spacer>
            <v-btn-small icon @click="get_questionarios">
                <v-icon>mdi-refresh</v-icon>
            </v-btn-small>
        </v-row>
        <v-divider class="my-2"></v-divider>
        <v-row v-for="q, ind in computedQuestionarios" :key="q.id">
            <v-col cols="12" class="px-0">
                <modal-gdb :code="'modal_code_quest_'+ind"
                    dialog-width="100%" 
                    :toolbar-title="q.titulo">
                    <template v-slot:activate-slot>
                        <slot name="modal-activate">
                            <v-btn style="width:100%">
                                <span v-html="q.titulo"></span>
                            </v-btn>
                        </slot>
                    </template>
                    <template v-slot:body>
                        <card-item>
                            <template v-slot:text>
                                <FormQuestionario 
                                    @on-update-form="onUpdatedForm" 
                                    @on-delete-form="onDeleteQuestionario('modal_code_quest_'+ind)" 
                                    :object="q" />
                            </template>
                        </card-item>
                    </template>
                </modal-gdb>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import FormQuestionario from '@/components/rh/FormQuestionario'
export default {
    name: 'RHQuestionarioComponent',
    components: {
        FormQuestionario
    },
    data: () => ({
        modal_code: 'modal_rh_questionario',
        selected_questionario: null,
        expansible: null
    }),
    methods: {
        async get_questionarios(){
            await this.$store.dispatch('GetRHQuestionarios')
        },
        init () {
            this.get_questionarios()
        },
        closeFormModal(){
            this.$refs[this.modal_code].dialog = false
        },
        onUpdatedForm(){
            this.$store.dispatch('GetRHPeriodoQuests')
            this.closeFormModal()
        },
        onCreatedForm(){
            this.closeFormModal()
        },
        onDeleteQuestionario(modal){
            this.$refs[modal].dialog = false
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        computedQuestionarios(){
            return this.$store.state.rh.questionarios
        }
    }
}
</script>